import { useMemo } from 'react';
import { IPipelineSummary } from '../pipelines.model';
import { usePipelinesOverview } from './usePipelinesOverview.query';

interface IDashboardCardsResult {
  summaries: IPipelineSummary[];
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
}

/** Memoized pipeline list from the overview envelope. */
export const useDashboardCards = (): IDashboardCardsResult => {
  const { data, isLoading, isFetching, isError } = usePipelinesOverview();
  const summaries = useMemo<IPipelineSummary[]>(
    () => data?.data.pipelines ?? [],
    [data?.data.pipelines]
  );

  return { summaries, isLoading, isFetching, isError };
};
